import React, { useCallback, useRef, useState } from 'react'
import styles from './ChatWidget.module.scss';
import ChatMessage from './ChatMessage';
import ChatTyping from './ChatTyping';
import { useSelector } from 'react-redux';
import useUserChatAction from 'src/hooks/useUserChatAction';
import clsx from 'clsx';

import { Button } from '@quantum-ecosystem/ui-toolkit';
import { IconSend2 } from '@tabler/icons-react';
import { Translate } from 'react-auto-translate';
import SafeImage from 'src/utils/SafeImage';

import { FormInput as TextInput } from 'src/components/forms';
const ChatScreen = () => {
    const [query, setQuery] = useState('');
    const { messages, isTyping, activeRoomData, agentLeftRoomData } = useSelector((state) => state.userChat);
    const { sendMessage, sendTypingStatus, leaveRoom } = useUserChatAction()
    const chatRef = useRef(null)

    const handleSendMessage = () => {
        if (!query.trim() || agentLeftRoomData) {
            return
        }
        sendMessage(query)
        setQuery('')
        setTimeout(() => {
            scrollToBottom()
        }, 500);
    }

    const scrollToBottom = useCallback(
        () => {
            if (chatRef.current) {
                chatRef.current.scrollTo({
                    top: chatRef.current.scrollHeight
                })
            }
        },
        [],
    )
    return (
		<>
			<div
				className={clsx(styles.header, styles['bottom-rounded'], 'p-3')}
			>
				<Button
					onClick={leaveRoom}
					size="sm"
					variant="outlined"
					className={styles['leave-chat-btn']}
				>
					<Translate>
						End chat
					</Translate>
				</Button>
				<div className="mt-2 d-flex align-items-center justify-content-center flex-column gap-1">
					<SafeImage
						src={activeRoomData?.userId?.profileImage}
						width={60}
						height={60}
						className="rounded-circle"
					/>
					<p className="text-center m-0 text-capitalize font-weight-bold">
						<Translate>
							{activeRoomData?.userId?.fname?.toLowerCase()}{' '}
							{activeRoomData?.userId?.lname?.toLowerCase()}
						</Translate>
					</p>
					<p className="tetx-center m-0 font-weight-light">
						<Translate>
							{activeRoomData?.userId?.title}
						</Translate>
					</p>
				</div>
			</div>
			<div className={clsx(styles.content, 'p-3')} ref={chatRef}>
				<div className="d-flex justify-content-center">
					<div className={clsx(styles.initialMessage)}>
						<Translate>
							{activeRoomData?.message}
						</Translate>
					</div>
				</div>
				{messages.map((message) => (
					<ChatMessage key={message} data={message} />
				))}
				{isTyping && <ChatTyping />}
				{agentLeftRoomData ? (
					<div className="d-flex justify-content-center text-center text-dark border-top">
						<p>
							<Translate>
								{agentLeftRoomData?.message}
							</Translate>
						</p>
					</div>
				) : null}
			</div>
			<div className={styles.footer}>
				<TextInput
					size="lg"
					variant="unstyled"
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							handleSendMessage();
						}
					}}
					value={query}
					onChange={(e) => setQuery(e.target.value)}
					placeholder="Type your message and hit Enter"
					onFocus={() => sendTypingStatus(true)}
					onBlur={() => sendTypingStatus(false)}
					disabled={Boolean(agentLeftRoomData)}
					rightSectionWidth={42}
					rightSection={
						<Button
							variant="ghost"
							size="sm"
							aria-label="Send"
							disabled={
								Boolean(agentLeftRoomData) || query.length === 0
							}
							onClick={handleSendMessage}
							style={{ padding: '4px', height: '28px', minWidth: '28px', color: '#009fdf' }}
						>
							<IconSend2 size={18} stroke={1.5} />
						</Button>
					}
				/>
			</div>
		</>
	);
}

export default ChatScreen